/**
 * 课程章节
 */

 import {
    get,
    post,
    put,
    del
  } from '@/util/request'

  /**
   * 根据Id查询
   * @param {*} Id
   * @returns
   */
  export const SelectCourseChapterById = (Id) => {
    return get('/api/app/CourseChapter?CurrentId=' + Id);
  }

  /**
   * 新增数据记录
   * @param {*} data
   * @returns
   */
  export const AddCourseChapter = (data) => {
    return post('/api/app/CourseChapter', data, {});
  }

  /**
   * 更新数据记录
   * @param {*} data
   * @returns
   */
  export const ModifyCourseChapter = (data) => {
    return put('/api/app/CourseChapter', data, {});
  }

  /**
   * 分页获取
   * @param {*} data
   * @returns
   */
  export const GetDataCourseChapterList = (data) => {
    return post('/api/app/CourseChapter/list', data, {});
  }

  /**
   * 删除记录
   * @param {*} id
   * @returns
   */
  export const DeleteCourseChapter = (id) => {
    return del('/api/app/CourseChapter/' + id, {}, {});
  }

  /**
 * 链表分页获取
 * @param {*} data
 * @returns
 */
 export const GetDataCourseChapterListByPageQuery = (data) => {
  return post('/api/app/CourseChapter/getDataByPageQuery', data, {});
}